import { axiosPrivate } from '@app/dashboard/tools/axios/axiosInstance';

export const getChargeBacks = ({
  currentPage,
  pageSize,
  isLive,
}: {
  currentPage: number;
  pageSize: number;
  isLive: boolean;
}) => {
  const queryParams = {
    page: currentPage,
    page_size: pageSize,
    is_live: isLive,
  };

  return axiosPrivate.get(`/dashboard/api/v1/chargeback`, { params: queryParams });
};

export const getSingleChargeBackDetails = (id: string) => {
  return axiosPrivate.get(`/dashboard/api/v1/chargeback/${id}`);
};
